import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMinus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 14,
	viewBox: "0 0 13 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.1875 6.75C12.1875 7.13281 11.8867 7.40625 11.5312 7.40625H1.46875C1.08594 7.40625 0.8125 7.13281 0.8125 6.75C0.8125 6.39453 1.08594 6.09375 1.46875 6.09375H11.5312C11.8867 6.09375 12.1875 6.39453 12.1875 6.75Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgIconMinus);
export { ForwardRef as ReactComponent };
